var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaugeArcRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 49.4108,
    height: 81.761,
    viewBox: "0 0 49.4108 81.761",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 526",
    d: "M41.8568 81.761C46.1794 81.761 49.7141 78.252 49.3902 73.9415C48.3459 60.044 44.5259 46.4685 38.1272 34.0282C31.7283 21.5878 22.9063 10.5852 12.208 1.65333C8.88988 -1.11698 3.97958 -0.282288 1.46568 3.23413V3.23413C-1.04822 6.75056 -0.209167 11.6139 3.07205 14.4279C11.7627 21.881 18.9478 30.9632 24.2071 41.1881C29.4663 51.413 32.676 62.54 33.6849 73.9443C34.0658 78.2501 37.5341 81.761 41.8568 81.761V81.761Z",
    fill: "#D76A66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeArcRed);
export default __webpack_public_path__ + "static/media/gauge-arc-red.843eaae2bf518da7f1405793f75464ca.svg";
export { ForwardRef as ReactComponent };